<template>
    <div id="top-message" @click="hide">
        <p v-if="currentMessage" :class="currentMessage.cssClassName" v-html="currentMessage.message"></p>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {State} from 'vuex-class';

    @Component({
        name: 'TopMessage',
    })
    export default class TopMessage extends Vue
    {
        @State('topMessages') topMessages: TopMessageData[];

        currentMessage: TopMessageData|null = null;

        timeout: number = 0;

        @Watch('topMessages')
        watchTopMessages()
        {
            this.nextMessage();
        }

        mounted()
        {
            this.nextMessage();
        }

        hide()
        {
            window.clearTimeout(this.timeout);
            this.$el.classList.remove('active');
            this.$el.addEventListener('transitionend', this.onTransitionEnd);
        }

        nextMessage()
        {
            if (this.topMessages.length === 0)
            {
                return;
            }
            else if (this.currentMessage)
            {
                // this.hide();
                return;
            }

            this.$el.classList.add('active');
            this.currentMessage = this.topMessages[0];
            this.timeout        = window.setTimeout(() => this.hide(), this.currentMessage.seconds * 1000);
        }

        onTransitionEnd()
        {
            this.$el.removeEventListener('transitionend', this.onTransitionEnd);

            if (this.currentMessage !== null)
            {
                if (typeof this.currentMessage.callback === 'function')
                {
                    this.currentMessage.callback();
                }

                this.currentMessage = null;
                this.$store.commit('topMessageShift');
            }
        }
    };
</script>
